import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { useLang } from "../context/LanguageContext";

export function Footer() {
  const s = useSettings();
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#0B1220] text-[#F4F8FF]">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-heading text-3xl">{s.footer_brand}</div>
          <p className="mt-4 text-sm text-[#F4F8FF]/60 font-light leading-relaxed max-w-xs">
            {s.footer_description}
          </p>
        </div>
        <div>
          <div className="overline text-[#5B9DFF] mb-4">{t("footer.company_title")}</div>
          <ul className="space-y-2 text-sm text-[#F4F8FF]/70 font-light">
            <li>{s.footer_company}</li>
            <li className="font-mono-ibn text-xs">IBAN: {s.footer_iban}</li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#5B9DFF] mb-4">{t("footer.nav_title")}</div>
          <ul className="space-y-2 text-sm text-[#F4F8FF]/70 font-light">
            <li><Link to="/" className="hover:text-[#5B9DFF] transition-colors">{t("footer.all_courses")}</Link></li>
            <li><Link to="/login" className="hover:text-[#5B9DFF] transition-colors">{t("footer.reserved")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F4F8FF]/10">
        <div className="px-6 md:px-12 max-w-[1400px] mx-auto py-6 text-xs text-[#F4F8FF]/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {s.footer_copyright}</span>
          <span>{t("footer.legal")}</span>
        </div>
      </div>
    </footer>
  );
}
